import { render, staticRenderFns } from "./BulkUpload.vue?vue&type=template&id=1caaf984&scoped=true&"
import script from "./BulkUpload.vue?vue&type=script&lang=js&"
export * from "./BulkUpload.vue?vue&type=script&lang=js&"
import style0 from "./BulkUpload.vue?vue&type=style&index=0&id=1caaf984&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1caaf984",
  null
  
)

export default component.exports